import '../../scripts/common';

import '../../scripts/autosize';
import 'animate.css/animate.css';
import '../../scripts/animate';
import '../../scripts/picture';
import '../../images/sprite/close_sm.svg';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Field from '../../components/base/Field';
import Share from '../../components/Share';
import PageScrollBtn from '../../components/simple/PageScrollBtn';
import ArticlesMiniList from '../../components/ArticlesMiniList';
import Spinner from '../../components/base/Spinner';
import Radio from '../../components/base/Radio';
import Breadcrumbs from '../../components/base/Breadcrumbs';

// Carousel
import Carousel from '../../components/base/Carousel';
import Rating from '../../components/base/Rating';
import ProductCard from '../../components/ProductCard';
import ProductQuickView from '../../components/ProductQuickView';
import Popup from '../../components/base/Popup';
import breakpoints from '../../scripts/variables';
import { media } from '../../scripts/helpers';

import './styles.css';

const $searchInput = $('#field-query');

$(() => {
    Header.create();
    Footer.create();
    Field.create();
    Spinner.create();
    Radio.create();
    Share.create();
    Breadcrumbs.create();
    initCarousel();
    Rating.create();
    initProductCard();
    initPopup();
    PageScrollBtn.create();
    ArticlesMiniList.create();
    initBtnClear();
});

function initCarousel() {
    const productsSearchSlidesCount = $('.swiper-slide', $('.carousel--products')).length;

    const carouselSearchProductsObj = new Carousel($('.carousel--products'));
    carouselSearchProductsObj.init(
        {
            reinitBreakpoints: [media('tabletLg')],
            reinitOptions: {
                default: {
                    loop: productsSearchSlidesCount > 4,
                },
                [breakpoints.mobileLg - 1]: {
                    loop: productsSearchSlidesCount > 2,
                },
                [breakpoints.tabletLg - 1]: {
                    loop: productsSearchSlidesCount > 3,
                },
            },
        },
        {
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
            slidesPerView: 4,
            loop: productsSearchSlidesCount > 4,
            slideToClickedSlide: false,
            breakpoints: {
                [breakpoints.mobileLg - 1]: {
                    slidesPerView: 2,
                },
                [breakpoints.tabletLg - 1]: {
                    slidesPerView: 3,
                },
            },
        }
    );
}

/**
 * Инициализация карточек товара
 */
function initProductCard() {
    $('.product-card').each((i, item) => {
        const productDefault = new ProductCard($(item));
        productDefault.init({});
    });

    ProductQuickView.create();
}

/**
 * Активация попапов
 */
function initPopup() {
    Popup.create();
}

function checkFieldEmpty() {
    if (!$('#field-query').val()) {
        $('.js-clear-field-query').removeClass('is-active');
    } else {
        $('.js-clear-field-query').addClass('is-active');
    }
}

/**
 * Инициализация поиска
 */
$('#search-no-result__search-wrap').submit(function() {
    const query = $('#field-query').val();
    $.ajax({
        url: `/api/internal/component/search:search.main`,
        method: 'post',
        data: {
            query,
        },
        success() {
            window.location.href = `/search?query=${query}`;
        },
    });
    return false;
});

$(document).on('click', '.js-clear-field-query', () => {
    $searchInput.val('');
    checkFieldEmpty();
    $searchInput.focus();
});

$searchInput.on('keyup', () => {
    checkFieldEmpty();
});

function initBtnClear() {
    $('.js-clear-field-query').appendTo('.js-no-result-field');
}
